export default {
  eyebrow: 'Portal do parceiro',
  title: 'Impostos e Moeda',
  description:
    'Categorias de imposto predefinidas que os seus restaurantes herdam, a menos que substituam uma categoria individualmente.',
};
